import { HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../environment/environment';
import { normaliserErreurHttp } from './api-error';

/** Placé avant l’authentification : le refresh traite les 401 avant leur normalisation. */
export const apiErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const base = environment.apiUrl.replace(/\/$/, '');
  if (req.url !== base && !req.url.startsWith(`${base}/`)) return next(req);
  return next(req).pipe(
    catchError((erreur: unknown) => throwError(() => normaliserErreurHttp(erreur))),
  );
};
